import type { ThanksContentResponse } from '@coorum-research/shared-common/api-response/thanks-content.schema'
import http from './http'

export function thanksContentApi() {
  const getThanksContent = async (id: string) => {
    const response = await http.get<ThanksContentResponse>(`/launcher-contents/${id}`)
    return response.data
  }

  return {
    getThanksContent,
  }
}
